import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://9b5e95e868a75ee0f506d859cf15ddb9@o1051356.ingest.us.sentry.io/4509554487984128",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  release: '2d96827a93dd0849b531d2fc1c0bcea1fe19c61e', // 🟢 Muss gesetzt sein
  sendDefaultPii: true
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
